import { render, staticRenderFns } from "./Dashboardprofile.vue?vue&type=template&id=2fc76652&"
import script from "./Dashboardprofile.vue?vue&type=script&lang=js&"
export * from "./Dashboardprofile.vue?vue&type=script&lang=js&"
import style0 from "./Dashboardprofile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports